// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"63ad1371","371":"46826eaa"}[chunkId] + ".chunk.js";
};